import { render, staticRenderFns } from "./servicesBlock.vue?vue&type=template&id=374927cf&scoped=true"
import script from "./servicesBlock.vue?vue&type=script&lang=js"
export * from "./servicesBlock.vue?vue&type=script&lang=js"
import style0 from "./servicesBlock.vue?vue&type=style&index=0&id=374927cf&prod&lang=sass&scoped=true"
import style1 from "./servicesBlock.vue?vue&type=style&index=1&id=374927cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374927cf",
  null
  
)

export default component.exports